import { otto } from "@gr-exports/async/nexus";
import { PREFIX } from "../lib/tracking/index.js";
export * from "../lib/tracking/index.js";
export * from "../lib/tracking/event/event.types.js";
const tracking = otto[PREFIX] ?? {};
const onInit = tracking.onInit;
const lockInit = tracking.lockInit;
const unlockInit = tracking.unlockInit;
export {
  lockInit,
  onInit,
  tracking,
  unlockInit
};
